<template>
    <div class="grid grid-cols-5 w-full">
        <div class="col-span-2 p-2">
            <CustomInput v-model="channelForm.name" class="w-full mt-1" type="text" placeholder="Boogi Technologies Ltd" label="Channel name" />

            <CustomSelect v-model="channelForm.type" :pre-select="channelForm.type" :options="channelType" label="Channel type" />

            <CustomInput v-model="channelForm.website" class="w-full mt-1" type="text" placeholder="https://boogi.uk" label="Website" />

            <div v-if="channelForm.type == 'INSTORE' || channelForm.type == 'ANY' ">

            <CustomInput v-model="channelForm.firstLineOfAddress" class="w-full mt-1" type="text" placeholder="https://boogi.uk" label="First line of address" />

            <CustomInput v-model="channelForm.city" class="w-full mt-1" type="text" placeholder="https://boogi.uk" label="City" />

            <CustomInput v-model="channelForm.postCode" class="w-full mt-1" type="text" placeholder="https://boogi.uk" label="Postcode" />

            </div>

            <div class="border-2 mt-2 p-2">
                <div class="flex justify-between mt-2 mb-4 items-center">
                    <label>Merchant identification codes (MIDs)</label>
                    <CustomButton @click="channelForm.mids.push(undefined)" class="ml-1" icon="Plus" small type="default" />
                </div>
                <div v-for="mid,index in channelForm.mids" :key="index" class="flex justify-between items-center border-bottom">
                    <p class="w-1/6 ml-1 mt-2">Mid {{index+1}}</p>
                    <CustomInput v-model="channelForm.mids[index]" class="w-full mt-1" type="text" placeholder="https://boogi.uk" />
                    <CustomButton @click="channelForm.mids.splice(index,1)" class="mt-1 ml-2" icon="Minus" small type="default" />

                </div>
            </div>



            <CustomButton class="mt-5" :disabled="!validForm" text="Add channel" icon="Plus" type="action" @click="createChannel()" />


        </div>
        <div class="col-span-3 p-2 justify-center">
            <div class="bg-[#F5F2FB] px-3 py-4 rounded-lg bg-opacity-60 grid gap-2">
                <p class="mb-1 text-sm font-medium">Saved channels:</p>
                <EasyDataTable :headers="headersTable1" :items="channels" :loading="loading"
                    v-model:server-options="serverOptions" :server-items-length="serverItemsLength" :hide-footer="false"
                    :no-hover="true"
                    class="overflow-x-auto"
                >
                    <template #loading>
                        <div class="p-4 w-full flex justify-center">
                            <svg class="animate-spin text-gray-400 w-12 h-12" xmlns="http://www.w3.org/2000/svg"
                                fill="none" viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                    stroke-width="4"></circle>
                                <path class="opacity-75" fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                </path>
                            </svg>
                        </div>
                    </template>
                    <template #empty-message>
                        <div class="flex justify-center py-4">
                            <div
                                class="flex justify-center items-center text-gray-500 rounded-full bg-gray-50 px-5 py-2 ">
                                <p class="text-sm mr-2">No results</p>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5" />
                                </svg>
                            </div>
                        </div>
                    </template>
                    <template #header-action="header">
                        <div class="w-full text-right">
                            {{ header.text }}
                        </div>
                    </template>

                    <template #item-action="channel">
                        <div @click="deleteChannel(channel)" class="flex justify-end items-center py-1 gap-1 hover:text-red-600 cursor-pointer">
                            <LucideIcon name="Trash2" :size="20" :stroke-width="1.7" />
                        </div>
                    </template>
                </EasyDataTable>
            </div>
        </div>

    </div>
</template>
<script>
import CustomInput from "@/components/inputs/CustomInput.vue";
import CustomButton from "@/components/inputs/CustomButton.vue";
import CustomSelect from "../inputs/CustomSelect.vue";
import LucideIcon from "../LucideIcon.vue";


export default {
    name: "channel-mapping",
    components: {
        CustomInput,
        CustomButton,
        CustomSelect,
        LucideIcon
    },
    props:{
        retailerData:{
            type:Object
        }
    },
    data() {
        return {
            channelType: [
                { "id": "ANY", "text": "Both" },
                { "id": "INSTORE", "text": "Instore" },
                { "id": "ONLINE", "text": "Online" }
            ],

            headersTable1: [
                { text: "Name", value: "channelName" },
                { text: "Website", value: "website" },
                { text: "Address", value: "address" },
                { text: "Postcode", value: "postcode" },
                { text: "MIDs", value: "mids" },
                { text: "Actions", value: "action" },

            ],
            channels: [

            ],
            serverItemsLength:undefined,
            channelForm:{
                name:"",
                type:"ONLINE",
                website:null,
                firstLineOfAddress: null,
                city:null,
                postCode:null,
                mids:[]
            },
            loading:false
        }

    },
    created(){
        this.getChannels(0,25)
    },
    methods:{

        async deleteChannel(channel) {
            this.loading = true
            const api = localStorage.getItem('apiType')

            try {
                const token = localStorage.getItem('token')

                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/bring-your-own-offer/channel/${channel.id}`, {
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    this.getChannels(0,25)
                }

            } catch {
                return
            }
        },

        async getChannels(page, size) {
            this.loading = true
            const api = localStorage.getItem('apiType')

            try {
                const token = localStorage.getItem('token')

                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/bring-your-own-offer/retailer/${this.retailerData.id}/channel?page=${page}&size=${size}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    var object = await response.json()
                    this.channels = object.content
                    this.$emit('formSubmit',this.channels.length > 0)
                    this.serverItemsLength = object.totalElements
                    this.loading = false
                }

            } catch {
                return
            }
        },

        async createChannel() {
            var channelRequest = {
                channelId: null,
                retailerId: this.retailerData.id,
                channelName: this.channelForm.name,
                channelType: this.channelForm.type,
                address: this.channelForm.firstLineOfAddress,
                city: this.channelForm.city,
                postcode: this.channelForm.postCode,
                website: this.channelForm.website,
                mids: this.channelForm.mids
            }

            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')

                this.loading = true

                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/bring-your-own-offer/channel`, {
                    method: "POST",
                    body: JSON.stringify(channelRequest),
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    this.channelForm = {
                name:"",
                type:"ONLINE",
                website:null,
                firstLineOfAddress: null,
                city:null,
                postCode:null,
                mids:[]
            }
                    this.getChannels(0,25)
                }

            } catch (error) {
                return;
            }
        },



        formSubmitted()
        {
            this.$emit("formSubmit",this.channelForm)
            this.channelForm = {
                name:"",
                type:"ONLINE",
                supplierChannelId:null,
                website:null,
                firstLineOfAddress: null,
                city:null,
                postCode:null,
                mids:[]
            }
        }

    },
    computed:{
        validForm(){
            if(this.channelForm.type == "ONLINE")
            {
                return this.channelForm.name != "" && this.channelForm.type != null && this.channelForm.website != null
            }else
            {
                return this.channelForm.name != "" && this.channelForm.type != null && this.channelForm.website != null && this.channelForm.firstLineOfAddress != null && this.channelForm.city != null && this.channelForm.postCode != null && this.channelForm.mids.length > 0
            }
        }
    }

}
</script>